import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
var LySvgService = /** @class */ (function () {
    function LySvgService(_http) {
        this._http = _http;
    }
    LySvgService.prototype.getSVG = function (url) {
        var _this = this;
        if (LySvgService._svg.has(url)) {
            return Promise.resolve(this._cloneSVG(LySvgService._svg.get(url)));
        }
        var req = this._http.get(url, { responseType: 'text' })
            .map(function (res) {
            var svgEl = _this._svgElementFromString(res);
            LySvgService._svg.set(url, svgEl);
            return _this._cloneSVG(svgEl);
        })
            .toPromise();
        return req;
    };
    LySvgService.prototype._svgElementFromString = function (str) {
        var div = document.createElement('DIV');
        div.innerHTML = str;
        var svg = div.querySelector('svg');
        if (!svg) {
            throw new Error('No SVG found in loaded contents');
        }
        return svg;
    };
    LySvgService.prototype._cloneSVG = function (svg) {
        return svg.cloneNode(true);
    };
    LySvgService._svg = new Map();
    LySvgService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    LySvgService.ctorParameters = function () { return [
        { type: HttpClient, },
    ]; };
    return LySvgService;
}());
export { LySvgService };
//# sourceMappingURL=ly-svg.service.js.map